import { UserRolesDefault } from "../features/admin/users/users.interfaces";
import { isKEMarket } from "../shared/shared.utils";
import { RoutesPrivileges } from "./routes.constants";

/**
    Retrieves the SFC notifications rules based on the current context.
    @returns {Array} An array of SFC notification rules.
*/
export const getSfcNotificationsRules = () => {
  if (isKEMarket()) {
    return RoutesPrivileges.sfcNotifications.filter(role => role !== UserRolesDefault.APPROVER);
  } else {
    return RoutesPrivileges.sfcNotifications;
  }
};
